import React, { useMemo } from 'react';
import { EArrowDirection } from 'utils/enums';

interface IRollingOfferArrowProps {
  direction: EArrowDirection;
  color?: string;
}

export const RollingOfferArrow: React.FC<IRollingOfferArrowProps> = ({
  direction,
  color = '#FFF12E',
}) => {
  const iconByDirection: Record<EArrowDirection, any> = useMemo(
    () => ({
      [EArrowDirection.DOWN]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="12"
          viewBox="0 0 20 12"
          fill="none"
          className="arrow-down"
        >
          <path
            d="M2 2L10 10L18 2"
            stroke="url(#paint0_linear_1_2561)"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1_2561"
              x1="10"
              y1="2"
              x2="10"
              y2="10"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor={color} />
              <stop offset="1" stopColor={color} />
            </linearGradient>
          </defs>
        </svg>
      ),
      [EArrowDirection.RIGHT]: (
        <div className={'side-arrow-container arrow-right'}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="20"
            viewBox="0 0 12 20"
            fill="none"
          >
            <path
              d="M2 18L10 10L2 2"
              stroke="url(#paint0_linear_1_2563)"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <defs>
              <linearGradient
                id="paint0_linear_1_2563"
                x1="2"
                y1="10"
                x2="10"
                y2="10"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor={color} />
                <stop offset="1" stopColor={color} />
              </linearGradient>
            </defs>
          </svg>
        </div>
      ),
      [EArrowDirection.LEFT]: (
        <div className={'side-arrow-container arrow-left'}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="20"
            viewBox="0 0 12 20"
            fill="none"
          >
            <path
              d="M10 18L2 10L10 2"
              stroke="url(#paint0_linear_1_2218)"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <defs>
              <linearGradient
                id="paint0_linear_1_2218"
                x1="10"
                y1="10"
                x2="2"
                y2="10"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor={color} />
                <stop offset="1" stopColor={color} />
              </linearGradient>
            </defs>
          </svg>
        </div>
      ),
    }),
    [direction, color],
  );

  return iconByDirection[direction];
};
